export default "__VITE_ASSET__DiYhJvn7__"